import { render, staticRenderFns } from "./CreateVendor.vue?vue&type=template&id=0ab5930c"
import script from "./CreateVendor.vue?vue&type=script&lang=js"
export * from "./CreateVendor.vue?vue&type=script&lang=js"
import style0 from "./CreateVendor.vue?vue&type=style&index=0&id=0ab5930c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports